import { useEffect } from 'react';
import { ensureNotificationSubscription } from '@/modules/gpt-chats/services/notification-client.service';

export const useNotificationListener = (
  notificationName: string,
  callback: (data: unknown) => void
) => {
  useEffect(() => {
    const unsubscribeFromHub = ensureNotificationSubscription(notificationName);

    const handleNotification = (event: CustomEvent) => {
      callback(event.detail);
    };

    window.addEventListener(notificationName, handleNotification as EventListener);

    return () => {
      unsubscribeFromHub();
      window.removeEventListener(notificationName, handleNotification as EventListener);
    };
  }, [callback, notificationName]);
};
